import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, useModal, useSystemFeedback } from 'react-style-guide';
import { getRobloxCreditBalance, redeemRobux } from '../services/robloxCreditService';

const [Modal, modalService] = useModal();
const [SystemFeedback, systemFeedbackService] = useSystemFeedback();

function RobloxCreditBase({ translate }) {
  const [balance, setBalance] = useState(null);
  const [robuxAmount, setRobuxAmount] = useState(null);
  const [canRedeemCreditForRobux, setCanRedeemCreditForRobux] = useState(null);

  const confirmationBody = (
    <div
      dangerouslySetInnerHTML={{
        __html: translate('Description.ConfirmRobloxCreditToRobuxRedemption', {
          balance,
          iconRobux: '<span class="icon-robux-16x16"></span>',
          robuxAmount
        })
      }}
    />
  );

  const getBalance = () => {
    getRobloxCreditBalance().then(data => {
      setBalance(parseFloat(data.balance).toFixed(2));
      setRobuxAmount(data.robuxAmount);
      setCanRedeemCreditForRobux(data.canRedeemCreditForRobux);
    });
  };

  const handleOnClick = () => {
    modalService.open().then(() => {
      redeemRobux().then(
        data => {
          if (data) {
            systemFeedbackService.success(
              translate('Message.RobloxCreditToRobuxRedemptionConfirmation', {
                robuxAmount
              })
            );
            getBalance();
          }
        },
        () => {
          systemFeedbackService.warning(translate('Message.FailedDebitRobloxCredit'));
        }
      );
    });
  };

  useEffect(() => {
    getBalance();
  }, []);

  return (
    <div>
      <span className='text-label account-settings-label'>{translate('Heading.RobloxCredit')}</span>
      <p> {translate('Label.CurrentBalance', { balance })}</p>
      {canRedeemCreditForRobux && (
        <Button
          id='redeem-robux-button'
          className='redeem-robux-button'
          variant={Button.variants.secondary}
          size={Button.sizes.medium}
          width={Button.widths.min}
          onClick={handleOnClick}>
          {translate('Action.ConvertToRobux')}
        </Button>
      )}
      <Modal
        title={translate('Heading.GetRobux')}
        body={confirmationBody}
        actionButtonText={translate('Action.Redeem')}
        neutralButtonText={translate('Action.Cancel')}
        actionButtonShow
      />
      <SystemFeedback />
    </div>
  );
}

RobloxCreditBase.propTypes = {
  translate: PropTypes.func.isRequired
};

export default RobloxCreditBase;
